import * as Sentry from '@sentry/angular';
import { bootstrapApplication } from '@angular/platform-browser';
import { Amplify } from 'aws-amplify';

import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config';
import { environment } from '@environment';

if (environment.production) {
  Sentry.init({
    dsn: 'https://c8aa2ea713506ce0b4218d757b63b787@o4510805893840896.ingest.us.sentry.io/4510805894037504',
    integrations: [Sentry.browserTracingIntegration()],
    tracesSampleRate: 1,
    enableLogs: true,
    sendDefaultPii: true,
  });
}

Amplify.configure({
  Auth: {
    Cognito: {
      //  Amazon Cognito User Pool ID
      userPoolId: environment.userPoolId,
      // OPTIONAL - Amazon Cognito Web Client ID (26-char alphanumeric string)
      userPoolClientId: environment.userPoolClientId,
      signUpVerificationMethod: 'code',
      loginWith: {
        // OPTIONAL - Hosted UI configuration
        oauth: {
          domain: environment.domain,
          scopes: ['email', 'openid', 'profile', 'aws.cognito.signin.user.admin'],
          redirectSignIn: ['http://localhost:4200/signin', 'https://app.expowizard.com'],
          redirectSignOut: ['http://localhost:4200/signin', 'https://app.expowizard.com/signin'],
          responseType: 'code', // or 'token', note that REFRESH token will only be generated when the responseType is code
        },
      },
    },
  },
});

bootstrapApplication(AppComponent, appConfig).catch(err => console.error(err));
